export const CONSENT_STORAGE_KEY = "homeindex_cookie_consent"
export const CONSENT_VERSION = "1"

export interface CookieConsent {
    necessary: true
    analytics: boolean
    marketing: boolean
    updatedAt: string
    version: string
}

export interface ConsentSelection {
    analytics: boolean
    marketing: boolean
}

export const DEFAULT_CONSENT_SELECTION: ConsentSelection = {
    analytics: false,
    marketing: false,
}

export function createConsent(selection: ConsentSelection, updatedAt = new Date().toISOString()): CookieConsent {
    return {
        necessary: true,
        analytics: !!selection.analytics,
        marketing: !!selection.marketing,
        updatedAt,
        version: CONSENT_VERSION,
    }
}

export function isCookieConsent(value: unknown): value is CookieConsent {
    if (!value || typeof value !== "object") {
        return false
    }

    const candidate = value as Partial<CookieConsent>
    return candidate.necessary === true
        && typeof candidate.analytics === "boolean"
        && typeof candidate.marketing === "boolean"
        && typeof candidate.updatedAt === "string"
        && typeof candidate.version === "string"
}
